// TODO: refactor to safely use it for words with more complex plural version f.i. policy, consider ability to force pluralization without count
const pluralize = (word: string, count: number) => (count === 1 ? word : `${word}s`);
const pluralizeVerb = (word: string, count: number) => (count === 1 ? `${word}s` : word);
const pluralizeNext = (count: number, word: string, plural?: string, article?: "a" | "an") => {
  const pluralized = plural || `${word}s`;

  if (count === 1) {
    return `${article ?? count} ${word}`;
  }

  return `${count} ${pluralized}`;
};

export { pluralize, pluralizeVerb, pluralizeNext };
